module.exports = __webpack_public_path__ + "static/img/logo.89e18319.jpg";